export default {
  eyebrow: 'Portal partener',
  title: 'Comisioane de procesare',
  description:
    'Plătești comisioanele Stripe la fiecare plată online. Comisionul de procesare setat aici este perceput restaurantelor tale pentru a le acoperi, cu excepția cazului în care un restaurant are propriul tarif.',
  card_title: 'Comision de procesare implicit',
  hint: 'Procent în %, plus o sumă fixă și una minimă opționale per plată. „Orice metodă de plată” se aplică dacă nu există o rată specifică metodei. Modificarea se aplică plăților efectuate după salvare.',
  hint_single:
    'Taxa de procesare se aplică fiecărei metode de plată online care nu are un tarif propriu. O modificare se aplică plăților efectuate după salvare.',
  hidden_rates:
    'Unele metode de plată au și propria rată, stabilită de suportul platformei. Acestea se aplică în locul acestei rate.',
  empty: {
    title: 'Niciun comision de procesare implicit setat',
    description:
      'Până când stabilești unul sau confirmi că nu percepi restaurantelor tale niciun comision de procesare, restaurantele tale care folosesc Stripe nu pot fi lansate, iar cele active nu primesc plăți online (numerarul funcționează în continuare).',
  },
  consent: {
    give: 'Plătim noi comisioanele Stripe (confirmă o marjă de 0%)',
    given_title: 'Marjă de 0% confirmată',
    given:
      'Confirmat de {{name}} la {{date}}: restaurantelor fără un tarif propriu nu li se percepe niciun comision de procesare, iar tu plătești comisioanele Stripe pentru plățile lor.',
    unknown_manager: 'un fost manager',
    withdraw: 'Retrage',
    withdraw_confirm: {
      title: 'Retrageți confirmarea marjei de 0%?',
      description:
        'Restaurantele fără un tarif propriu nu pot fi lansate, iar cele active nu mai primesc plăți online până când stabiliți un tarif sau confirmați din nou.',
    },
  },
  buttons: {
    edit: 'Editează',
    cancel: 'Anulează',
    save: 'Salvează',
  },
  toasts: {
    load_error: 'Comisioanele tale de procesare nu au putut fi încărcate.',
    failed_to_save_changes: 'Comisioanele tale de procesare nu au putut fi salvate.',
    changes_got_saved: 'Comisioane de procesare salvate',
    consent_given: 'Marjă de 0% confirmată',
    consent_withdrawn: 'Confirmare retrasă',
  },
};
